import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "setting-table-row" }
const _hoisted_5 = { class: "header cell-label age" }
const _hoisted_6 = { class: "header cell-label setting" }
const _hoisted_7 = { class: "header cell-label calc" }
const _hoisted_8 = { class: "setting-table-row border" }
const _hoisted_9 = { class: "setting-cell cell-label age" }
const _hoisted_10 = { class: "setting-texts" }
const _hoisted_11 = { class: "setting-cell cell-label setting" }
const _hoisted_12 = { class: "setting-texts" }
const _hoisted_13 = { class: "setting-cell cell-label calc" }
const _hoisted_14 = { class: "setting-texts" }
const _hoisted_15 = { class: "setting-table-row border" }
const _hoisted_16 = { class: "setting-cell cell-label age" }
const _hoisted_17 = { class: "setting-texts" }
const _hoisted_18 = { class: "setting-cell cell-label setting" }
const _hoisted_19 = { class: "setting-texts" }
const _hoisted_20 = { class: "setting-cell cell-label calc" }
const _hoisted_21 = { class: "setting-texts" }
const _hoisted_22 = { class: "setting-table-row border" }
const _hoisted_23 = { class: "setting-cell cell-label age" }
const _hoisted_24 = { class: "setting-texts" }
const _hoisted_25 = { class: "setting-cell cell-label setting" }
const _hoisted_26 = { class: "setting-texts" }
const _hoisted_27 = { class: "setting-cell cell-label calc" }
const _hoisted_28 = { class: "setting-texts" }
const _hoisted_29 = { class: "setting-table-row border" }
const _hoisted_30 = { class: "setting-cell cell-label age" }
const _hoisted_31 = { class: "setting-texts" }
const _hoisted_32 = { class: "setting-cell cell-label setting" }
const _hoisted_33 = { class: "setting-texts" }
const _hoisted_34 = { class: "setting-cell cell-label calc" }
const _hoisted_35 = { class: "setting-texts" }
const _hoisted_36 = { class: "setting-table-row border" }
const _hoisted_37 = { class: "setting-cell cell-label age" }
const _hoisted_38 = { class: "setting-texts" }
const _hoisted_39 = { class: "setting-cell cell-label setting" }
const _hoisted_40 = { class: "setting-texts" }
const _hoisted_41 = { class: "setting-cell cell-label calc" }
const _hoisted_42 = { class: "setting-texts" }
const _hoisted_43 = { class: "per-age-round-row" }
const _hoisted_44 = { class: "per-age-round-row-header" }
const _hoisted_45 = { class: "setting-texts" }
const _hoisted_46 = { class: "per-age-round-row-cell" }
const _hoisted_47 = { class: "setting-texts" }
const _hoisted_48 = { class: "mb-2 mt-16" }
const _hoisted_49 = { class: "setting-texts bold mb-4" }
const _hoisted_50 = { class: "setting-texts" }
const _hoisted_51 = { class: "mb-2 mt-16" }
const _hoisted_52 = { class: "per-age-round-row" }
const _hoisted_53 = { class: "per-age-round-row-header" }
const _hoisted_54 = { class: "setting-texts" }
const _hoisted_55 = { class: "per-age-round-row-cell" }
const _hoisted_56 = { class: "setting-texts" }
const _hoisted_57 = { class: "per-age-round-row-header" }
const _hoisted_58 = { class: "setting-texts" }
const _hoisted_59 = { class: "per-age-round-row-cell" }
const _hoisted_60 = { class: "setting-texts" }
const _hoisted_61 = { style: {"width":"300px"} }
const _hoisted_62 = {
  class: "mx-2",
  style: {"width":"40px"}
}
const _hoisted_63 = { style: {"width":"300px"} }
const _hoisted_64 = { class: "mb-2 mt-16" }
const _hoisted_65 = {
  class: "per-age-round-row",
  style: {"gap":"1rem"}
}
const _hoisted_66 = { class: "per-age-round-row-header" }
const _hoisted_67 = { class: "setting-texts" }
const _hoisted_68 = { style: {"width":"240px"} }
const _hoisted_69 = { class: "d-flex mt-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_hour_minute_input = _resolveComponent("hour-minute-input")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.placementSetting)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.title')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.age')), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.setting')), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.formula')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.age0')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.staffLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age0,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.placementSetting.perChildren.age0) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.perLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age0,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.placementSetting.perStaff.age0) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childrenLabel')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childCountLabel')) + " × " + _toDisplayString(_ctx.placementSetting.perChildren.age0) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age0), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.age1')), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.staffLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.placementSetting.perChildren.age1) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.perLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age1,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.placementSetting.perStaff.age1) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childrenLabel')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childCountLabel')) + " × " + _toDisplayString(_ctx.placementSetting.perChildren.age1) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age1), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.age2')), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.staffLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age2,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.placementSetting.perChildren.age2) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.perLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age2,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.placementSetting.perStaff.age2) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childrenLabel')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childCountLabel')) + " × " + _toDisplayString(_ctx.placementSetting.perChildren.age2) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age2), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.age3')), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.staffLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age3,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.placementSetting.perChildren.age3) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.perLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age3,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.placementSetting.perStaff.age3) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childrenLabel')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childCountLabel')) + " × " + _toDisplayString(_ctx.placementSetting.perChildren.age3) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age3), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.age4Plus')), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.staffLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age4,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.placementSetting.perChildren.age4) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.perLabel')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age4,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.placementSetting.perStaff.age4) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childrenLabel')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.childCountLabel')) + " × " + _toDisplayString(_ctx.placementSetting.perChildren.age4) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age4), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.commonCalc')), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section1.decimalPoint')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_select, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"160px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.roundingPerAge.decimalPlaces,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.placementSetting.roundingPerAge.decimalPlaces) = $event)),
                      items: [
                    { value: 1, title: _ctx.$t('workScheduling.placementSetting.section1.decimalFirst') },
                    { value: 2, title: _ctx.$t('workScheduling.placementSetting.section1.decimalSecond') },
                  ],
                      color: "primary"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_select, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"160px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.roundingPerAge.action,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.placementSetting.roundingPerAge.action) = $event)),
                      items: [
                    { value: 'down', title: _ctx.$t('workScheduling.placementSetting.section1.roundDown') },
                    { value: 'normal', title: _ctx.$t('workScheduling.placementSetting.section1.roundNormal') },
                    { value: 'up', title: _ctx.$t('workScheduling.placementSetting.section1.roundUp') },
                  ],
                      color: "primary"
                    }, null, 8, ["modelValue", "items"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("h2", _hoisted_48, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section2.title')), 1),
            _createElementVNode("div", _hoisted_49, [
              _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.section2.description')) + " ", 1),
              _createElementVNode("span", null, [
                _createVNode(_component_v_select, {
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  style: {"width":"160px"},
                  class: "mx-2",
                  modelValue: _ctx.placementSetting.roundingAll.action,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.placementSetting.roundingAll.action) = $event)),
                  items: [
                { value: 'down', title: _ctx.$t('workScheduling.placementSetting.section1.roundDown') },
                { value: 'normal', title: _ctx.$t('workScheduling.placementSetting.section1.roundNormal') },
                { value: 'up', title: _ctx.$t('workScheduling.placementSetting.section1.roundUp') },
              ],
                  color: "primary"
                }, null, 8, ["modelValue", "items"])
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section2.additionalFormula')), 1)
            ]),
            _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section2.minimumNote')), 1),
            _createElementVNode("h2", _hoisted_51, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section3.title')), 1),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section3.additionalStaff')), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.additional.staffCount,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.placementSetting.additional.staffCount) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.placementSetting.section3.staffCount')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section3.range')), 1)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("span", _hoisted_61, [
                    _createVNode(_component_hour_minute_input, {
                      modelValue: _ctx.placementSetting.additional.startMin,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.placementSetting.additional.startMin) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section3.from')), 1),
                  _createElementVNode("span", _hoisted_63, [
                    _createVNode(_component_hour_minute_input, {
                      modelValue: _ctx.placementSetting.additional.endMin,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.placementSetting.additional.endMin) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.showHourlyWageForSpecialCareSection)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h2", _hoisted_64, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section4.title')), 1),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('workScheduling.placementSetting.section4.hourlyWage')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined",
                      suffix: _ctx.$t('workScheduling.placementSetting.section4.yen'),
                      modelValue: _ctx.placementSetting.subsidyChildcare.hourlyWageAmount,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.placementSetting.subsidyChildcare.hourlyWageAmount) = $event)),
                      type: "number",
                      color: "primary"
                    }, null, 8, ["suffix", "modelValue"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isUpdating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 1,
                class: "my-2",
                indeterminate: "",
                color: "primary"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              size: "large",
              variant: "flat",
              color: "primary",
              onClick: _ctx.updatePlacementSetting
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.placementSetting.save')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_spacer)
          ])
        ], 64))
  ]))
}